"use client";
import { useState } from "react";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import {
  Dialog,
  DialogTitle,
  DialogDescription,
  DialogBody,
} from "@/components/atoms/dialog";
import { Button } from "@/components/atoms/button";

interface InfoTooltipProps {
  message: string;
  title?: string;
  description?: string;
  className?: string;
}

export default function InfoTooltip({
  message,
  title = "Information",
  description = "Additional details",
  className = "",
}: InfoTooltipProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className={`group relative ${className}`}>
        <InformationCircleIcon
          className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-help"
          onClick={() => setModalOpen(true)}
        />
        {/* Desktop Tooltip */}
        <div className="hidden md:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none w-64 z-10">
          <div className="text-center">{message}</div>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
        </div>
      </div>

      {/* Mobile Modal */}
      <Dialog open={modalOpen} onClose={setModalOpen}>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
        <DialogBody>
          <p className="text-sm text-gray-600 mb-4">{message}</p>
          <div className="flex justify-end">
            <Button onClick={() => setModalOpen(false)} color="blue">
              Got it
            </Button>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
}
